export const stateName = 'banners' as const
